import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api";
import { t } from "../i18n";
import LangBar from "../components/LangBar";

export default function MePage({ lang, setLang }) {
  const { user, token, logout, updateUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [msg, setMsg] = useState("");

  const save = async () => {
    const updated = await api("/api/auth/profile", {
      method: "PATCH",
      token,
      body: { name, language: lang },
    });
    updateUser(updated);
    setMsg(t(lang, "save"));
  };

  return (
    <div className="tt-page">
      <h2>{t(lang, "me")}</h2>
      <p className="tt-muted">{user?.phone}</p>
      <label>
        {t(lang, "name")}
        <input value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <p>{t(lang, "language")}</p>
      <LangBar
        lang={lang}
        onChange={async (code) => {
          setLang(code);
          const updated = await api("/api/auth/profile", {
            method: "PATCH",
            token,
            body: { language: code },
          });
          updateUser(updated);
        }}
      />
      <button className="tt-btn" onClick={save}>
        {t(lang, "save")}
      </button>
      {msg && <p className="tt-ok">{msg}</p>}
      <button className="tt-btn ghost" onClick={logout}>
        {t(lang, "logout")}
      </button>
      <p className="tt-foot">{t(lang, "neverStop")}</p>
    </div>
  );
}
